export default {
  theme: state => state.curTheme
}